import * as React from 'react'
import InputPrefixSuffixComponent from './input-prefix-suffix.component'

type Props = Omit<JSX.IntrinsicElements['input'], 'type' | 'spellCheck'> & {
  /** prevents the browser from remembering the password as an autocomplete suggestion before sending the form by setting showRevealButton to false (https://www.makethingsaccessible.com/guides/make-an-accessible-password-reveal-input/) */
  showRevealButton: boolean
}

export default function InputPasswordComponent ({ showRevealButton, ...inputProps }: Props) {
  const [showPassword, setShowPassword] = React.useState<boolean>(false)

  const suffix = React.useMemo(() => {
    if (!showRevealButton) return null
    return <button type="button" className="fakeInput u-plm u-prm u-mbn" style={{ border: 'none', background: 'transparent', height: '100%' }} onClick={ () => setShowPassword(val => !val) } tabIndex={ -1 }>
      <em className={ showPassword ? 'icon-view-off' : 'icon-view'  } />
    </button>
  }, [showPassword, showRevealButton])

  return <InputPrefixSuffixComponent suffix={ suffix } suffixClassName={ `u-pan ${inputProps.className}` }>
    {/* disable spellcheck to avoid sending PII to cloud when browser do enhanced spell check (https://www.bleepingcomputer.com/news/security/google-microsoft-can-get-your-passwords-via-web-browsers-spellcheck/) */}
    <input { ...inputProps } type={ showRevealButton && showPassword ? 'text' : 'password' } spellCheck={ false } />
  </InputPrefixSuffixComponent>
}
